import * as types from '../types/adTypes';
import * as adService from '../../services/adService';
import { getApiCountryCode } from '../../services/http';
import { makeServerEventKey } from '../../utils/adTracking';
import { logAdsVerbose } from '../../config/ads';
import { selectAdsManagedEnabled } from '../reducers/sitePublicReducer';

export const adPlacementKey = (page, placement, scope = '') => `${page}:${placement}:${scope || 'global'}`;

export const fetchAdPlacement = ({ page, placement, scope = '', params = {} }) => async (dispatch, getState) => {
  const key = adPlacementKey(page, placement, scope);
  dispatch({ type: types.FETCH_AD_PLACEMENT_REQUEST, meta: { key } });
  try {
    const mergedParams = {
      ...params,
      page: params.page != null && params.page !== '' ? params.page : page,
      placement: params.placement != null && params.placement !== '' ? params.placement : placement,
    };
    if (logAdsVerbose) {
      console.log('[simimovies/ads] fetchAdPlacement dispatch → API', {
        key,
        managedAdsEnabled: selectAdsManagedEnabled(getState()),
        params: mergedParams,
      });
    }
    const data = await adService.getAdPlacements(mergedParams);
    if (logAdsVerbose) {
      const first = Array.isArray(data) && data[0] ? data[0] : null;
      console.log('[simimovies/ads] fetchAdPlacement success', {
        key,
        count: Array.isArray(data) ? data.length : 0,
        firstCampaignId: first?._id ? String(first._id) : null,
        firstName: first?.name || null,
        firstHasCreative: !!(first?.creative && first.creative.imageUrl),
        firstHasDestination: !!(first?.creative && first.creative.destinationUrl),
      });
    }
    dispatch({ type: types.FETCH_AD_PLACEMENT_SUCCESS, payload: data, meta: { key } });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch ad placement';
    const status = error.response?.status;
    console.warn('[simimovies/ads] placements request failed', {
      key,
      status: status || null,
      message,
      hint: status === 400 ? 'Often: no active Website for X-Site (see response body).' : null,
    });
    if (logAdsVerbose) {
      console.warn('[simimovies/ads] fetchAdPlacement failure detail', {
        key,
        message,
        status,
        body: error.response?.data,
      });
    }
    dispatch({ type: types.FETCH_AD_PLACEMENT_FAILURE, payload: message, meta: { key } });
  }
};

export const trackAdImpression = (payload) => async (dispatch) => {
  dispatch({ type: types.TRACK_AD_EVENT_REQUEST });
  try {
    const merged = { ...payload, country: payload.country || getApiCountryCode() || '' };
    const eventKey = merged.eventKey || makeServerEventKey(merged, 'impression');
    await adService.trackAdImpression({ ...merged, eventKey });
    dispatch({ type: types.TRACK_AD_EVENT_SUCCESS });
  } catch (_error) {
    dispatch({ type: types.TRACK_AD_EVENT_FAILURE });
  }
};

export const trackAdClick = (payload) => async (dispatch) => {
  dispatch({ type: types.TRACK_AD_EVENT_REQUEST });
  try {
    const merged = { ...payload, country: payload.country || getApiCountryCode() || '' };
    const eventKey = merged.eventKey || makeServerEventKey(merged, 'click');
    await adService.trackAdClick({ ...merged, eventKey });
    dispatch({ type: types.TRACK_AD_EVENT_SUCCESS });
  } catch (_error) {
    dispatch({ type: types.TRACK_AD_EVENT_FAILURE });
  }
};
